<template>
    <td-dialog
        :title="title"
        :before-close="resetPasswordDialogClose"
        :visible.sync="dialogResetPasswordVisible"
        width="32%"
        append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <input type="password" style="outline:none;border:0;width:0;height:0;float:left;background-color: rgba(0, 0, 0, 0);" />
        <el-form :model="formResetPasswordInfo" ref="formResetPasswordInfo" :rules="rules">
            <el-form-item :label="$t('common.USERNAME')" :label-width="formLabelWidth" prop="sName">
                <td-input v-model="formResetPasswordInfo.sName"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.NEWPASSWORD')" :label-width="formLabelWidth" prop="sNewPassword">
                <td-input v-model="formResetPasswordInfo.sNewPassword" type="password"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.CONFIRMATION')" :label-width="formLabelWidth" prop="sConfirmPassword">
                <td-input type="password" v-model="formResetPasswordInfo.sConfirmPassword"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="resetPassword()">{{ $t('common.RESETTOSTART') }}</td-button>
            <td-button type="primary" @click="submitForm('formResetPasswordInfo')">{{ $t('common.RESET') }}</td-button>
            <td-button type="button" @click.native="resetPasswordDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogResetPasswordVisible', 'editItem'],
    created() {
        this.initEditData();
        this.initRegex();
    },
    // 定义变量
    data() {
        let validateUserName = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formResetPasswordInfo.sId;
            }
            let param = {
                sName: value,
                sId: sId,
                sysFlg: this.formResetPasswordInfo.sSysFlg
            };
            // console.log(param)
            resourceApi.getUserInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_USER_CAPTION_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        let validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else {
                if (this.formResetPasswordInfo.sConfirmPassword !== '') {
                    this.$refs.formResetPasswordInfo.validateField('sConfirmPassword');
                }
                callback();
            }
        };
        let validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else if (this.formResetPasswordInfo.sNewPassword !== value) {
                callback(this.$t('error.ERROR_PASSWORD_NOT_EQUAl'));
            } else {
                callback();
            }
        };
        return {
            // ResetPassword表单信息
            formResetPasswordInfo: {
                sId: '',
                sNewPassword: '',
                sConfirmPassword: '',
                sName: '',
                sSysFlg: ''
            },
            formLabelWidth: '30%',
            passwordRule: '',
            ruleMessage: '',
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    },
                    { validator: validateUserName, trigger: 'blur' }
                ],
                sNewPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validatePassword, trigger: 'blur' }
                ],
                sConfirmPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validateConfirmPassword, trigger: 'blur' }
                ]
            }
        };
    },

    // 定义并实现方法体
    methods: {
        initRegex() {
            let params = {
                sTag: 'PASSWORD_RULE'
            };
            window.vue.$api.getDictValuesByType(JSON.stringify(params), response => {
                this.passwordRule = response.data.content[0].sCode;
                this.ruleMessage = response.data.content[0].sValue;
                let regx = {
                    pattern: this.passwordRule,
                    message: this.ruleMessage
                };
                this.rules.sNewPassword.push(regx);
            });
        },
        // 初始化编辑数据
        initEditData() {
            this.formResetPasswordInfo.sId = this.editItem.userId;
            this.formResetPasswordInfo.sName = this.editItem.userName;
            this.formResetPasswordInfo.sSysFlg = this.editItem.sSysFlg;
        },
        checkChange(item, node, self) {
            if (node === true) {
                // 点击未选中复选框
                this.editCheckId = item.sId;
                this.$refs.tree.setCheckedKeys([item.sId]);
            } else {
                if (this.editCheckId === item.sId) {
                    // 点击已选中复选框，保证至少一个选中
                    this.$refs.tree.setCheckedKeys([item.sId]);
                }
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.formResetPasswordInfo.sNewPassword !== this.formResetPasswordInfo.sConfirmPassword) {
                        this.$message({ showClose: true, message: this.$t('error.ERROR_PASSWORD_NOT_EQUAl'), type: 'error' });
                        return;
                    }

                    let content = {
                        sId: this.formResetPasswordInfo.sId,
                        sName: this.formResetPasswordInfo.sName,
                        newPassword: this.formResetPasswordInfo.sNewPassword,
                        sysFlg: this.formResetPasswordInfo.sSysFlg
                    };
                    resourceApi.resetPassword(JSON.stringify(content), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('user/resetPassword', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                        this.$emit('resetPasswordDialogClose');
                        this.$emit('userDialogClose');
                        this.$emit('submit');
                    });
                }
            });
        },
        resetPassword() {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formResetPasswordInfo.sId;
            }
            let param = {
                sName: this.formResetPasswordInfo.sName,
                sId: sId,
                sysFlg: this.formResetPasswordInfo.sSysFlg
            };
            // console.log(param)
            resourceApi.getUserInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    // this.$message.error(this.$t('error.ERROR_USER_CAPTION_REPEAT'))
                } else {
                    this.formResetPasswordInfo.sNewPassword = '';
                    this.formResetPasswordInfo.sConfirmPassword = '';
                    let content = {
                        sId: this.formResetPasswordInfo.sId,
                        sName: this.formResetPasswordInfo.sName,
                        sysFlg: this.formResetPasswordInfo.sSysFlg
                    };
                    resourceApi.resetPassword(JSON.stringify(content), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('user/resetPassword', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                        this.$emit('resetPasswordDialogClose');
                        this.$emit('userDialogClose');
                    });
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        resetPasswordDialogClose() {
            this.$emit('resetPasswordDialogClose');
            this.$refs['formResetPasswordInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
